import { resumeData } from '../resume.data';
import type { ResumeData } from '../resume.types';

export function useResumeData(): ResumeData {
  return resumeData;
}
